// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gtuqQnkHYkwY267A h1 {
  text-align: center;
  padding: 36px;
  margin: 0;
  background-color: #ffffff;
  font-family: Roboto;
  font-weight: bold;
  font-size: 36px;
}

.PGPuRt8ysYIgJRKd {
  display: flex;
  height: calc(100vh - 115px);
  overflow-y: hidden;
}

.jegBldaQiA8_9y5t,
.N76uOFLOMsEl8oWX {
  width: 50%;
}

.jegBldaQiA8_9y5t {
  background: #fbf2ec;
  color: #48392f;
}

.jegBldaQiA8_9y5t .ZeAuXzf2TU4sg9l0 {
  background-color: #eeccb8;
  padding: 38px 0px;
  padding-left: 114px;
  color: #303030;
  font-family: Roboto;
  font-size: 40px;
  font-weight: bold;
  font-style: italic;
}

.N76uOFLOMsEl8oWX {
  background: #f9fffa;
  color: #283d2d;
}

.N76uOFLOMsEl8oWX .ZeAuXzf2TU4sg9l0 {
  background-color: #a7d5b2;
  padding: 38px 0px;
  padding-left: 114px;
  color: #303030;
  font-family: Roboto;
  font-size: 40px;
  font-weight: bold;
  font-style: italic;
}

.qIDnB1VTBgjTogtx {
  display: flex;
  flex-wrap: wrap;
}

.pUoWe1qALmoEkDWw {
  width: 32%;
  color: #48392f;
  font-family: Montserrat;
  font-size: 78px;
  font-weight: 800;
  padding: 57px 0px 0px 114px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StatusScreen/StatusScreen.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":[".pageWrapper h1 {\r\n  text-align: center;\r\n  padding: 36px;\r\n  margin: 0;\r\n  background-color: #ffffff;\r\n  font-family: Roboto;\r\n  font-weight: bold;\r\n  font-size: 36px;\r\n}\r\n\r\n.columnsWrapper {\r\n  display: flex;\r\n  height: calc(100vh - 115px);\r\n  overflow-y: hidden;\r\n}\r\n\r\n.columnInProgress,\r\n.columnReady {\r\n  width: 50%;\r\n}\r\n\r\n.columnInProgress {\r\n  background: #fbf2ec;\r\n  color: #48392f;\r\n}\r\n\r\n.columnInProgress .columnHeader {\r\n  background-color: #eeccb8;\r\n  padding: 38px 0px;\r\n  padding-left: 114px;\r\n  color: #303030;\r\n  font-family: Roboto;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  font-style: italic;\r\n}\r\n\r\n.columnReady {\r\n  background: #f9fffa;\r\n  color: #283d2d;\r\n}\r\n\r\n.columnReady .columnHeader {\r\n  background-color: #a7d5b2;\r\n  padding: 38px 0px;\r\n  padding-left: 114px;\r\n  color: #303030;\r\n  font-family: Roboto;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  font-style: italic;\r\n}\r\n\r\n.orders {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.orderNumber {\r\n  width: 32%;\r\n  color: #48392f;\r\n  font-family: Montserrat;\r\n  font-size: 78px;\r\n  font-weight: 800;\r\n  padding: 57px 0px 0px 114px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `gtuqQnkHYkwY267A`;
export var columnsWrapper = `PGPuRt8ysYIgJRKd`;
export var columnInProgress = `jegBldaQiA8_9y5t`;
export var columnReady = `N76uOFLOMsEl8oWX`;
export var columnHeader = `ZeAuXzf2TU4sg9l0`;
export var orders = `qIDnB1VTBgjTogtx`;
export var orderNumber = `pUoWe1qALmoEkDWw`;
export default ___CSS_LOADER_EXPORT___;
